import gql from 'graphql-tag';

export const COMPANIES_QUERY = gql`
  query companies {
    companies {
      id
      tradingName
      companyType
      nominatedExecutor
      executorship
      offerTrustAdministration
      trustCompanyName
      trustCompanyRegNo
      willPaymentOption
      negotiableExecutorFee
      defaultExecutorFeePercentage
      executorFeeLocation
      insuranceStep
      numberOfAdvisors
      numberOfCompanyAdmins
      numberOfTestators
      numberOfCompletedWills
      numberOfFiduciaryConsultants
      campaignCode
      campaignAssistedCode
      advisorAppointment
      oneStreamTeamId
      oneStreamTagId
      oneStreamInsuranceTagId
      oneStreamUtmSource
      oneStreamUrl
      coBrandedBannerTitle
      coBrandedBannerDescription
      commission
      commissionScheme
      willDownloadLanguages
    }
  }
`;

export const CREATE_OR_UPDATE_COMPANY_MUTATION = gql`
  mutation createOrUpdateCompany($id: ID, $companyInputDetails: CompanyInput!) {
    createOrUpdateCompany(id: $id, companyInput: $companyInputDetails) {
      id
      tradingName
      nominatedExecutor
      executorship
      offerTrustAdministration
      trustCompanyName
      trustCompanyRegNo
      willPaymentOption
      negotiableExecutorFee
      defaultExecutorFeePercentage
      executorFeeLocation
      insuranceStep
      address
      logoUrl
      companyType
      referAFriend
      willUploadReminderEmail
      hideQuickwillLogoOnWill
      contactCenterWorkflow
      numberOfAdvisors
      numberOfCompanyAdmins
      numberOfTestators
      numberOfCompletedWills
      advisorAppointment
      oneStreamTeamId
      oneStreamTagId
      oneStreamInsuranceTagId
      oneStreamUtmSource
      oneStreamUrl
      coBrandedBannerTitle
      coBrandedBannerDescription
      commission
      commissionScheme
      ratherChatEnabled
      speakToDfaAdvisorEnabled
      sppOneStreamId
      willDownloadLanguages
      objectCommissionPairs {
        id
        commissionObjectType
        commissionObjectId
        parentObjectType
        parentObjectId
        limitAmount
        limitDate
        usedAmount
        active
        limit
        willCommission {
          id
          trigger
          value
          valueCents
          createdAt
          updatedAt
        }
        policyCommission {
          id
          type
          value
          cadence
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const TRANSFER_TESTATORS_MUTATION = gql`
  mutation transferTestators(
    $advisorId: ID!
    $transferToAdvisorId: ID!
    $testatorIds: [ID!]!
  ) {
    transferTestators(
      advisorId: $advisorId
      transferToAdvisorId: $transferToAdvisorId
      testatorIds: $testatorIds
    )
  }
`;

export const COMPANY_QUERY = gql`
  query company($id: ID!) {
    company(id: $id) {
      id
      tradingName
      nominatedExecutor
      executorship
      offerTrustAdministration
      trustCompanyName
      trustCompanyRegNo
      willPaymentOption
      negotiableExecutorFee
      defaultExecutorFeePercentage
      executorFeeLocation
      insuranceStep
      address
      logoUrl
      companyType
      referAFriend
      willUploadReminderEmail
      hideQuickwillLogoOnWill
      contactCenterWorkflow
      campaignCode
      campaignAssistedCode
      advisorAppointment
      oneStreamTeamId
      oneStreamTagId
      oneStreamInsuranceTagId
      oneStreamUtmSource
      oneStreamUrl
      coBrandedBannerTitle
      coBrandedBannerDescription
      commission
      commissionScheme
      ratherChatEnabled
      speakToDfaAdvisorEnabled
      sppOneStreamId
      willDownloadLanguages
      objectCommissionPairs {
        id
        commissionObjectType
        commissionObjectId
        parentObjectType
        parentObjectId
        limitAmount
        limitDate
        usedAmount
        active
        limit
        willCommission {
          id
          trigger
          value
          valueCents
          createdAt
          updatedAt
        }
        policyCommission {
          id
          type
          value
          cadence
          createdAt
          updatedAt
        }
      }
    }
  }
`;

export const USER_COMPANY_QUERY = gql`
  query user($id: ID!) {
    user(id: $id) {
      id
      company {
        id
        tradingName
        nominatedExecutor
        executorship
        offerTrustAdministration
        trustCompanyName
        trustCompanyRegNo
        willPaymentOption
        negotiableExecutorFee
        defaultExecutorFeePercentage
        executorFeeLocation
        insuranceStep
        address
        logoUrl
        companyType
        referAFriend
        willUploadReminderEmail
        hideQuickwillLogoOnWill
        contactCenterWorkflow
        commission
        commissionScheme
      }
    }
  }
`;

export const COMPANY_USERS_QUERY = gql`
  query companyUsers(
    $id: ID!
    $includeTestators: Boolean
    $dateRange: [ISO8601Date!]
  ) {
    companyUsers(
      id: $id
      includeTestators: $includeTestators
      dateRange: $dateRange
    ) {
      id
      fullName
      email
      role
      acceptedTerms
      testatorId
      testatorCount
      validUploadedWillCount
      willCount
      numberOfRegistrations
      numberOfWillsCompleted
    }
  }
`;

export const SIMPLE_COMPANIES_QUERY = gql`
  query simpleCompanies {
    companies {
      id
      tradingName
      companyType
    }
  }
`;
